import {CONSTANTS} from "../../constants/constants";
import {SVG_ICON} from "../common/svg/svg-icon";

export const ACTIVE_COLOR = '#E89732';
export const INACTIVE_COLOR = '#7c7c7c';

const {
  PROFILE,

  PROPERTY,
  CAR,
  TOUR,
  AUTH,

  PROPERTY_SEARCH,
  CAR_SEARCH,
  TOUR_SEARCH,
} = CONSTANTS.ROUTES;

const {
  NAV_STAY,
  NAV_CAR,
  NAV_TOUR,
  LOGIN,
} = SVG_ICON;

export const tabsConfig = [
  {
    title: 'rentalTypes.stays',
    paths: [
      PROPERTY.path,
      PROPERTY_SEARCH.path,
    ],
    link: PROPERTY.path,
    icon: NAV_STAY,
  },
  {
    title: 'rentalTypes.cars',
    paths: [
      CAR.path,
      CAR_SEARCH.path,
    ],
    link: CAR.path,
    icon: NAV_CAR,
  },
  {
    title: 'rentalTypes.activities',
    paths: [
      TOUR.path,
      TOUR_SEARCH.path
    ],
    link: TOUR.path,
    icon: NAV_TOUR
  },
];

export const authTabConfig = {
  title: 'signIn',
  paths: [
    AUTH.path,
  ],
  link: AUTH.path,
  icon: LOGIN,
};

export const userTabConfig = {
  paths: [
    PROFILE.path
  ],
  link: PROFILE.path
}

export const selectUser = (state) => ({
  isAuth: state.user.isAuth,
  language: state.user.language,
});
